import React, { useEffect, useState } from 'react';
import { Controller } from "react-hook-form";
import {
    Box,
    Card,
    CardContent,
    FormControl,
    Grid,
    Select,
    Typography
} from "@deere/fuel-react";
import {generateFiscalYear, getSelectedSubFunctionalAreas} from "../shared/utils";
import {useAuthConfig} from "../shared/helper";
import { useOktaAuth } from "@okta/okta-react";
import AutoCompleteCheckbox from "../shared/AutoCompleteCheckbox";

export const RatingProgramFunctionalArea = ({control, onSelectStep, currentData, setValue, isFunctionalAreaError, functionalAreaErrorDesc, isSubFuncAreaError, subFuncAreaErrorDesc}) => {
    let authAxios = useAuthConfig();
    const { authState } = useOktaAuth();
    const [fyList, setFyList] = useState([]);
    const [currentYear, setCurrentYear] = useState();
    const [functionalAreas, setFunctionalAreas] = useState([]);
    const [subFunctionalAreas, setSubFunctionalAreas] = useState([]);
    const [selectedFunctionalAreas, setSelectedFunctionalAreas] = useState(currentData.functionalAreas ? currentData.functionalAreas : []);
    const [selectedSubFunctionalAreas, setSelectedSubFunctionalAreas] = useState(currentData.subFunctionalAreas ? currentData.subFunctionalAreas : []);

    const handleFunctionalArea = value => {
        setSelectedFunctionalAreas(value)
        const tempSubFunctionalAreas = value.map(item => item.subFunctionalArea && item.subFunctionalArea)
        setSubFunctionalAreas([...new Set(tempSubFunctionalAreas.flat())]);
    }

    const handleSubFunctionalArea = value => {
       setSelectedSubFunctionalAreas(value)
    }

    const getFunctionalArea = async () => {
        try {
            return await authAxios.get(`/functional-areas`);
        } catch (e) {
            console.error(e);
        }
    };

    const getCurrentCalendar = async () => {
        try {
            return await authAxios.get(`/calendar/current`);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        onSelectStep(0);

        getCurrentCalendar().then(res => {
            setCurrentYear(res.data.currentFiscalYear)
            setValue("fiscalYear", currentData.fiscalYear ? currentData.fiscalYear : res.data.currentFiscalYear)
            const list = generateFiscalYear(res.data.currentFiscalYear);
            setFyList(list);
        });

        getFunctionalArea().then(res => {
            setFunctionalAreas(res.data);
        });
        return () => {
            setFyList([]);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState]);

    useEffect(() => {
        if (functionalAreas.length > 0) {
            const subFunctionalAreaList = getSelectedSubFunctionalAreas(currentData.functionalAreas, functionalAreas);
            setSubFunctionalAreas([...new Set(subFunctionalAreaList.flat())])
        }
    }, [functionalAreas, currentData.functionalAreas]);

    return (
        <Grid container>
            <Grid item xs={4}>
                <Box mt={6}>
                    <Card>
                        <CardContent>
                            <Grid container alignItems="center" spacing={4}>
                                <Grid item xs={12}>
                                    <Typography size="sm" component="p" fontWeight="bold" display="block">What period do you want feedback for? {" "}
                                        <span
                                            aria-label="required field"
                                            className="uxf-is-required"
                                        >
                                            *
                                        </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography>Fiscal Year</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl>
                                        <Controller
                                            rules={{ required: true }}
                                            control={control}
                                            defaultValue={currentData.fiscalYear ? currentData.fiscalYear : currentYear}
                                            name={"fiscalYear"}
                                            render={({ onChange, value }) => (
                                                <Select native
                                                    labelId={"fiscalYear"}
                                                    id={"fiscalYear"}
                                                    value={value}
                                                    onChange={(e) => {
                                                        onChange(e);
                                                    }}>
                                                    {fyList && fyList.map((item, index) => {
                                                        return (
                                                            <option
                                                                key={index}
                                                                value={item}>{item}</option>
                                                        );
                                                    })
                                                    }
                                                </Select>
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Box>
            </Grid>
            <Grid item xs={8}>
                <Box m={6}>
                    <Card>
                        <CardContent>
                            <Grid container alignItems="center" spacing={4}>
                                <Grid item xs={7}>
                                    <AutoCompleteCheckbox
                                        name={"functionalAreas"}
                                        label={"Functional Area"}
                                        showLabel={true}
                                        options={functionalAreas}
                                        control={control}
                                        defValue={selectedFunctionalAreas}
                                        onOptionsChange={handleFunctionalArea}
                                        isError={isFunctionalAreaError}
                                        errorDesc={functionalAreaErrorDesc}
                                        required={true}
                                    />
                                </Grid>
                                <Grid item xs={7}>
                                    <AutoCompleteCheckbox
                                        name={"subFunctionalAreas"}
                                        label={"Sub Functional Area"}
                                        options={subFunctionalAreas}
                                        control={control}
                                        defValue={selectedSubFunctionalAreas}
                                        onOptionsChange={handleSubFunctionalArea}
                                        isError={isSubFuncAreaError}
                                        errorDesc={subFuncAreaErrorDesc}
                                        required={true}
                                        showLabel={true}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Box>
            </Grid>
        </Grid>
    );
};
